import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  TextField,
} from '@material-ui/core';
import React, { useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import ManageSearchIcon from '@material-ui/icons/ManageSearch';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import { useStyles } from '../styles';
import { TicketFormData } from '../interfaces';
import UserList from '../../../tools-provisioning/components/common/UserList';

const TicketPopup = ({
  data,
  open,
  type,
  onClose,
  onDelete,
  onSubmit,
}: any) => {
  const classes = useStyles();
  const [clear, setClear] = useState<number>(0);
  const [errMsg, setErrMsg] = useState<string>('');
  const [saveTicketData, setSaveTicketData] = useState<TicketFormData>(() => {
    const baseFields = {
      snow_ticket_number: type === 'editTicket' ? data?.snow_ticket_number : '',
      assigned_to: type === 'editTicket' ? data?.assigned_to : '',
      assigned_by: '',
      created_by: '',
      application_name: type === 'editTicket' ? data?.application_name : '',
      last_modified_by: '',
      tower: type === 'editTicket' ? data?.tower : '',
      region: type === 'editTicket' ? data?.region : '',
      description: type === 'editTicket' ? data?.description : '',
      snow_link: '',
      status: '',
    };
    if (type === 'editTicket') {
      return {
        ...baseFields,
        id: data?.id, // Only include id in edit mode
      };
    }
    return {
      ...baseFields, // Only include in non-edit mode
    };
  });

  const [saveNewAsset, setSaveNewAsset] = useState(() => {
    const baseFields = {
      ticket_id: data?.ticketNumber,
      asset_name: type === 'edit' ? data?.asset?.asset_name : '',
      asset_description: type === 'edit' ? data?.asset?.asset_description : '',
      asset_store_id: type === 'edit' ? data?.asset?.asset_store_id : '',
      asset_type: type === 'edit' ? data?.asset?.asset_type : '',
      asset_kind: type === 'edit' ? data?.asset?.asset_kind : '',
      tech_owner: type === 'edit' ? data?.asset?.tech_owner : '',
      tech_owner_email: type === 'edit' ? data?.asset?.tech_owner_email : '',
      expected_delivery_date:
        type === 'edit' ? data?.asset?.expected_delivery_date : '',
      status: type === 'edit' ? data?.asset?.status : 'In Progress',
      additional_contributers:
        type === 'edit' ? data?.asset?.additional_contributers : [],
      component_link: type === 'edit' ? data?.asset?.component_link : '',
      is_new_asset: type === 'edit' ? data?.asset?.is_new_asset : true,
    };
    if (type === 'edit') {
      return {
        ...baseFields,
        id: data?.asset?.id, // Only include id in edit mode
      };
    }
    return {
      ...baseFields,
      snow_ticket_number: data?.ticketId, // Only include in non-edit mode
    };
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setSaveTicketData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAutoCompleteChange = (value: any) => {
    setSaveTicketData(prev => ({
      ...prev,
      assigned_to: value?.user || '',
    }));
  };

  const handleChangeNewAsset = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setSaveNewAsset(prev => ({
      ...prev,
      [name]:
        name === 'expected_delivery_date'
          ? new Date(value).toISOString() // Convert to ISO format
          : name === 'additional_contributers'
          ? value.split(',').map(item => item.trim())
          : value,
    }));
  };

  const handleSubmit = () => {
    switch (type) {
      case 'add':
        if (!saveTicketData.assigned_to) {
          setErrMsg('Please select an assignee');
        } else if (!saveTicketData.snow_ticket_number) {
          setErrMsg('Please fill in ticket number');
        } else {
          onSubmit('ticket', saveTicketData);
        }
        break;
      case 'editTicket':
        onSubmit('ticket', saveTicketData);
        break;
      case 'newAsset':
        onSubmit('newAsset', saveNewAsset);
        break;
      case 'edit':
        onSubmit('edit', saveNewAsset);
        break;
      default:
        console.log('submit default');
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <div className={classes.popupTitle}>
        <DialogTitle>
          <span>
            {type === 'add'
              ? 'Add ticket'
              : type === 'editTicket'
              ? 'Edit ticket'
              : type === 'newAsset'
              ? 'New reusable asset'
              : type === 'edit' && `Ticket no: #${data?.ticketId}`}
          </span>
        </DialogTitle>
        <IconButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <Divider />
      <DialogContent
        className={classes.dialogContent}
        classes={{ root: classes.dialogFieldFlow }}
      >
        {type === 'add' || type === 'editTicket' ? (
          <>
            <TextField
              required
              name="snow_ticket_number"
              value={saveTicketData.snow_ticket_number}
              onChange={handleChange}
              placeholder="Enter ticket number"
              label="Ticket number"
              variant="outlined"
              fullWidth
            />
            <TextField
              required
              name="description"
              value={saveTicketData.description}
              onChange={handleChange}
              placeholder="Enter description"
              label="Description"
              variant="outlined"
              fullWidth
              multiline
              minRows={4}
            />
            {/* <TextField
              required
              name="assigned_to"
              value={saveTicketData.assigned_to}
              onChange={handleChange}
              placeholder="Search"
              label="Assign Owner"
              variant="outlined"
              fullWidth
              InputProps={{
                endAdornment: (
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                ),
              }}
            /> */}
            <Grid item xs={12}>
              <UserList
                onChange={handleAutoCompleteChange}
                clear={clear}
                max={1}
                label="Assign Owner"
                initValue={saveTicketData.assigned_to}
              />
            </Grid>
            <TextField
              required
              name="application_name"
              value={saveTicketData.application_name}
              onChange={handleChange}
              label="Application Name"
              variant="outlined"
              fullWidth
            >
            </TextField>
            <TextField
              name="tower"
              value={saveTicketData.tower}
              onChange={handleChange}
              label="Line of Business"
              variant="outlined"
              select
              fullWidth
            >
              {
                ["BOE", "Advisory", "REI", "Corporate"].map((tower) => (
                  <MenuItem key={tower} value={tower}>{tower}</MenuItem>
                ))
              }
            </TextField>
            <TextField
              name="region"
              value={saveTicketData.region}
              onChange={handleChange}
              label="Region"
              variant="outlined"
              select
              fullWidth
            >
              {
                ["APAC", "EMEA", "Americas", "Global"].map((region) => (
                  <MenuItem key={region} value={region}>{region}</MenuItem>
                ))
              }
            </TextField>
            {/* <TextField
              required
              name="application_name"
              value={saveTicketData.application_name}
              onChange={handleChange}
              label="Application Name"
              variant="outlined"
              select
              fullWidth
            >
              <MenuItem value="MarketIQ">MarketIQ</MenuItem>
              <MenuItem value="PeopleSoft">PeopleSoft</MenuItem>
            </TextField>
            <TextField
              required
              name="tower"
              value={saveTicketData.tower}
              onChange={handleChange}
              label="Tower"
              variant="outlined"
              select
              fullWidth
            >
              <MenuItem value="CIO">CIO</MenuItem>
              <MenuItem value="REI">REI</MenuItem>
            </TextField>
            <TextField
              required
              name="snow_link"
              value={saveTicketData.snow_link}
              onChange={handleChange}
              placeholder="Enter link"
              label="Servicenow link"
              variant="outlined"
              fullWidth
            /> */}
          </>
        ) : (
          (type === 'newAsset' || type === 'edit') && (
            <>
              <TextField
                required
                name="asset_name"
                value={saveNewAsset.asset_name}
                onChange={handleChangeNewAsset}
                placeholder="Enter here"
                label="Title"
                variant="outlined"
                fullWidth
              />
              <TextField
                required
                name="asset_description"
                value={saveNewAsset.asset_description}
                onChange={handleChangeNewAsset}
                placeholder="Enter description"
                label="Description"
                variant="outlined"
                fullWidth
                multiline
                minRows={4}
              />
              <TextField
                required
                name="tech_owner"
                value={saveNewAsset.tech_owner}
                onChange={handleChangeNewAsset}
                placeholder="Search"
                label="Tech Owner"
                variant="outlined"
                fullWidth
                InputProps={{
                  endAdornment: (
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  ),
                }}
              />
              <TextField
                required
                name="tech_owner_email"
                value={saveNewAsset.tech_owner_email}
                onChange={handleChangeNewAsset}
                placeholder="Search"
                label="Tech Owner Email"
                variant="outlined"
                fullWidth
                InputProps={{
                  endAdornment: (
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  ),
                }}
              />
              <TextField
                type="date"
                name="expected_delivery_date"
                value={
                  saveNewAsset.expected_delivery_date
                    ? new Date(saveNewAsset.expected_delivery_date)
                        .toISOString()
                        .split('T')[0]
                    : ''
                }
                onChange={handleChangeNewAsset}
                variant="outlined"
                fullWidth
                label="Expected Date"
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                name="asset_type"
                value={saveNewAsset.asset_type}
                onChange={handleChangeNewAsset}
                variant="outlined"
                select
                fullWidth
                label="Asset type"
              >
                <MenuItem value="Component">Component</MenuItem>
                <MenuItem value="API">API</MenuItem>
              </TextField>
              <TextField
                required
                name="component_link"
                value={saveNewAsset.component_link}
                onChange={handleChangeNewAsset}
                placeholder="Enter link"
                label="Component Link"
                variant="outlined"
                fullWidth
              />
              <TextField
                required
                name="additional_contributers"
                value={
                  Array.isArray(saveNewAsset.additional_contributers)
                    ? saveNewAsset.additional_contributers.join(', ')
                    : ''
                }
                onChange={handleChangeNewAsset}
                placeholder="Search"
                label="Email reminders"
                variant="outlined"
                fullWidth
                InputProps={{
                  endAdornment: (
                    <IconButton>
                      <ManageSearchIcon />
                    </IconButton>
                  ),
                }}
              />
              {type === 'edit' && (
                <>
                  <TextField
                    variant="outlined"
                    name="status"
                    value={saveNewAsset.status}
                    onChange={handleChangeNewAsset}
                    select
                    fullWidth
                    label="Change status"
                  >
                    <MenuItem value="Delivered">Delivered</MenuItem>
                    <MenuItem value="Not Delivered">Not Delivered</MenuItem>
                    <MenuItem value="Yet to come">Yet to come</MenuItem>
                  </TextField>
                </>
              )}
            </>
          )
        )}
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogActions }}>
        {type === 'editTicket' && (
          <Button
            onClick={() => onDelete(data?.id)}
            color="primary"
            variant="outlined"
            className={classes.deleteButton}
          >
            <DeleteOutlinedIcon />
            Delete
          </Button>
        )}
        <div>
          <Button onClick={onClose} color="primary" variant="text">
            Cancel
          </Button>
          <Button onClick={handleSubmit} color="primary" variant="contained">
            {type === 'add'
              ? 'Add'
              : type === 'newAsset'
              ? 'Submit'
              : (type === 'edit' || type === 'editTicket') && 'Update'}
          </Button>
        </div>
      </DialogActions>
      {errMsg && <div className={classes.popupError}>{errMsg}</div>}
    </Dialog>
  );
};

export default TicketPopup;
